import { render, staticRenderFns } from "./ProfileExtraInfo.vue?vue&type=template&id=1cad8078&"
import script from "./ProfileExtraInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileExtraInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports